<ui-card
    variant="internal"
    shape="square"
    display="full-space"
>
    <table ui-table>
        <tbody>
            @let itemPrincipal = field?.valor_principal ?? "SIM";
            @let _principalWasSelected = wasSelected (itemPrincipal);
            @let _principalHasCondicional = hasConditional (itemPrincipal);
            @let _principalIsInconsistency = isInconsistency (itemPrincipal);

            @let _letHighlight = _principalWasSelected || _principalHasCondicional || _principalIsInconsistency;

        <tr ui-table-row
            [highlight]="_letHighlight"
            [highlightColor]="getHighlightColor(_principalWasSelected,
                                                _principalIsInconsistency,
                                                _principalHasCondicional)"
            (click)="selectItem(itemPrincipal)"
            class="cursor-pointer"
        >
            <td class="col-1">
                <ui-switch
                    [checked]="data.valor === itemPrincipal"
                    [disableToggle]="true"
                ></ui-switch>
            </td>
            <td
                class="col-10"
            >
                {{ itemPrincipal }}
            </td>

            <td class="col-1">
                @if (hasTriggeredConditional (itemPrincipal)) {
                    <ui-button
                        variant="outline"
                        color="secondary"
                        (click)="showConditionalGroup(itemPrincipal)"
                    >
                        <i class="fa fa-edit"></i>
                    </ui-button>
                }
            </td>
        </tr>

            @let itemSecondary = field?.valor_secundario ?? "NÃO";
            @let _secondaryWasSelected = wasSelected (itemSecondary);
            @let _secondaryHasCondicional = hasConditional (itemSecondary);
            @let _secondaryIsInconsistency = isInconsistency (itemSecondary);

            @let _letSecondaryHighlight = _secondaryWasSelected || _secondaryHasCondicional || _secondaryIsInconsistency;

        <tr ui-table-row
            [highlight]="_letSecondaryHighlight"
            [highlightColor]="getHighlightColor(_secondaryWasSelected,
                                                _secondaryIsInconsistency,
                                                _secondaryHasCondicional)"
            (click)="selectItem(itemSecondary)"
            class="cursor-pointer"
        >
            <td class="col-3">
                <ui-switch
                    [checked]="data.valor === itemSecondary"
                    [disableToggle]="true"
                ></ui-switch>
            </td>
            <td
                class="col-6"
            >
                {{ itemSecondary }}
            </td>

            <td class="col-3">
                @if (hasTriggeredConditional(itemSecondary)) {
                    <ui-button
                        variant="outline"
                        color="secondary"
                        (click)="showConditionalGroup(itemSecondary)"
                    >
                        <i class="fa fa-edit"></i>
                    </ui-button>
                }
            </td>
        </tr>
        </tbody>
    </table>
</ui-card>

@if (validateConditional ()) {
    <app-material-input
        label="Justifique"
        [required]="true"
    >
        <textarea [(ngModel)]="data.outro_valor">
        </textarea>
    </app-material-input>
}
